/**
 * Get the page event label for tracking purposes.
 * This function reads the label determined by the Rails backend via a meta tag,
 * ensuring consistent labeling across all international domains and URL structures.
 *
 * @returns {string} The page event label (e.g., 'home', 'templates_resume', 'examples_resume_show')
 */
export const getPageLabel = () => {
  const metaTag = document.querySelector('meta[name="page-event-label"]')

  if (metaTag && metaTag.content) {
    return metaTag.content
  }

  return window.location.pathname
}
